'use client';

import AddToCart from 'components/actions/add-to-cart/add-to-cart';
import ViewReplacement from 'components/actions/view-replacement/view-replacement';
import { ProductPriceAvailability } from 'services/priceAvailability/types';
import { OrderItemPart } from 'services/cart/types';
import { ProductsPriceData } from 'app/[lang]/[esite]/(core)/search/_components/analytics-listener/types';
import { productCategoryCommonLogic } from 'components/product-comparison-grid/product-comparison-card/utils';
import ViewDetails from 'components/actions/view-details/view-details';
import { LocationAddress } from 'services/location/types';
import ContactDealerMobileDrawer from 'components/contact-dealer-mobile-drawer/contact-dealer-mobile-drawer';

export interface ProductSpecsMobileDrawerFooterProps {
  product?: Product;
  cartId?: string;
  locationId?: string;
  orderItem?: OrderItemPart;
  productPriceData?: ProductsPriceData;
  isRegistrationPendingApproval?: boolean;
  isHeadlessPDPEnabled?: boolean;
  location?: {
    isCustomerSupportEnabled?: boolean;
    locale?: string;
    locationAddress?: LocationAddress;
  };
}

export default function ProductSpecsMobileDrawerFooter({
  product,
  cartId,
  locationId,
  orderItem,
  productPriceData,
  isRegistrationPendingApproval,
  isHeadlessPDPEnabled,
  location
}: Readonly<ProductSpecsMobileDrawerFooterProps>) {
  const { quantity, sosCode } = productPriceData.productPriceData;

  const productPrice = {
    partNumber: productPriceData?.partNumber,
    partName: product?.name,
    quantity,
    sosCode
  } as ProductPriceAvailability;

  const { showAddCart, hasReplacement } = productCategoryCommonLogic(
    productPriceData?.productPriceData,
    isRegistrationPendingApproval,
    product?.type
  );

  return (
    <>
      {!hasReplacement && (
        <ViewDetails
          partNumber={product?.partNumber}
          productURL={product?.seoURL ?? product?.productURL}
          isHeadlessPDPEnabled={isHeadlessPDPEnabled}
        />
      )}
      {showAddCart && (
        <AddToCart
          productPrice={productPrice}
          productPriceData={productPriceData}
          cartId={cartId}
          locationId={locationId}
          orderItem={orderItem}
          size="md"
        />
      )}
      {hasReplacement && (
        <ViewReplacement
          partNumber={productPriceData?.partNumber}
          productURL={productPriceData.productURL}
          isHeadlessPDPEnabled={isHeadlessPDPEnabled}
          size="md"
        />
      )}
      {!showAddCart && !hasReplacement && (
        <ContactDealerMobileDrawer
          locale={location?.locale}
          dealerAddress={location?.locationAddress}
          isCustomerSupportEnabled={location?.isCustomerSupportEnabled}
          variant="contrast"
          size="md"
        />
      )}
    </>
  );
}
